import { c as _c } from "react/compiler-runtime";
import { EditProfileView } from "@repo/ui/components/profile/EditProfileView";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { authClient } from "@/clients/authClient";
import { jsx as _jsx } from "react/jsx-runtime";
export const Route = createFileRoute("/_app/mitt-konto/redigera-profil")({
  component: EditProfilePage
});
function EditProfilePage() {
  const $ = _c(10);
  const navigate = useNavigate();
  const {
    data: session
  } = authClient.useSession();
  if (!session) {
    return null;
  }
  let t0;
  let t1;
  if ($[0] !== navigate) {
    t0 = () => navigate({
      to: "/mitt-konto"
    });
    t1 = () => navigate({
      to: "/mitt-konto"
    });
    $[0] = navigate;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== navigate) {
    t2 = () => navigate({
      to: "/mitt-konto"
    });
    $[3] = navigate;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== session.user || $[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = /*#__PURE__*/_jsx(EditProfileView, {
      authClient: authClient,
      user: session.user,
      onSuccess: t0,
      onBack: t1,
      statusMessage: null,
      onStatusMessageAction: t2
    });
    $[5] = session.user;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}